export default __webpack_public_path__ + "5a2a357bc76eb7c44e8740dc76650eb4.png";